import {Card, Container, Group, Menu, rem, Stack, Text, Title, UnstyledButton} from "@mantine/core";
import {useMemo, useState} from "react";
import {useGetAllWellsQuery, wellsSelector} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {IconChevronDown} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import {ResizeableContent} from "../../components/ResizableContent/ResizableContent";
import {PAGINATION_PAGE_SIZES} from "../../components/data-table/DataTable/usePagination";
import {WellDataTable} from "../../components/data-table/WellDataTable/WellDataTable";
import {useApp} from "../../providers/RegionProvider/RegionProvider";
import {ProtectedPage} from "../../components/page/ProtectedPage/ProtectedPage";

export type WellPageProps = {
  // page props here
}

export const WellDataTablePage = (props: WellPageProps) => {

  const {t} = useTranslation(["translation", "common"]);
  const {regionId} = useApp();

  const [access, setAccess] = useState(false);

  const selectWells = useMemo(() => {
    return wellsSelector();
  }, []);

  const {wells, isLoading, error, refetch,} = useGetAllWellsQuery(access ? (regionId ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      ...result,
      wells: selectWells(result, undefined),
      isLoading: result.isLoading,
      error: result.error,
    })
  });

  return (
    <ProtectedPage permissions={["well_view"]} isLoading={isLoading} error={error} onAccess={setAccess}>
      {(classes) => (
        <ResizeableContent>
          {(size) => (
            <Container h={size.height} w={size.width} className={classes.container} fluid={true} p="md">
              <Stack h="100%" m="sm">
                <Card shadow="sm" padding="lg" mb="lg" radius="md" withBorder>
                  <Group position="apart">
                    <Title
                      order={4}>{t("page.well.title", "Wells", {ns: "translation"})}</Title>
                    <Menu
                      width={260}
                      position="bottom-end"
                      transitionProps={{transition: "pop-top-right"}}
                      withinPortal
                    >
                      <Menu.Target>
                        <UnstyledButton>
                          <Group spacing={7}>
                            <Text weight={500} size="sm" sx={{lineHeight: 1}} mr={3}>
                              Actions
                            </Text>
                            <IconChevronDown size={rem(12)} stroke={1.5}/>
                          </Group>
                        </UnstyledButton>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Menu.Item onClick={() => refetch()}>
                          {t("actions.refresh", "Refresh", {ns: "common"})}
                        </Menu.Item>
                      </Menu.Dropdown>
                    </Menu>
                  </Group>
                </Card>
                <WellDataTable
                  withBorder
                  records={wells}
                  recordsPerPageOptions={PAGINATION_PAGE_SIZES}
                  fetching={isLoading}/>
              </Stack>
            </Container>
          )}
        </ResizeableContent>
      )}
    </ProtectedPage>
  );
};
